// @ts-nocheck
import { httpClient } from '../../../core/network';

class CustomerService {
  static deletePicDiscounts(pic) {
    const apiUrl = '/customers/paymentinfo/discount';
    return httpClient.delete(apiUrl, {
      params: { pic },
    });
  }

  static deletePicBlock(pic) {
    const apiUrl = `/customers/paymentinfo/${pic}/block`;
    return httpClient.delete(apiUrl);
  }

  static deleteUserBlock(userId) {
    const apiUrl = `/customers/subscriber/${userId}/block`;
    return httpClient.delete(apiUrl);
  }

  static registerFlow(userId: string, flowType: string) {
    const apiUrl = `/customers/${userId}/flow-triggers`;
    return httpClient.patch(
      apiUrl,
      { 'flow-type': flowType }
    );
  }
}

export default CustomerService;
